import { render } from "./Card.vue?vue&type=template&id=bf185c84"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=bf185c84&lang=css"

import exportComponent from "/Users/marco/Documents/VueJS/marco-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__